<div class="general-container flex flex-col justify-center items-center">
  <div *ngIf="loading" class="body-content flex flex-col items-center w-full md:max-w-[40%] gap-16">
    <fun-skeleton-list></fun-skeleton-list>
  </div>
  <div class="content flex flex-col justify-center items-center gap-x-32 gap-y-80 place-content-center relative">
    <div *ngIf="!loading" class="body-content flex flex-col items-center w-full md:max-w-[40%] gap-16">
      <!---->
      <section *ngIf="step === 0">
        <h2 class="font-sans text-eggplant-100 text-3xl">{{ 'LOCAL_INNVEST.STEP_0.TITLE' | translate }}</h2>
        <p class="subtitle txt_1 font-sans text-l text-eggplant-100/[0.55]">{{ 'LOCAL_INNVEST.STEP_0.SUBTITLE' | translate:{'projectName':projectName} }}</p>
        <div class="info_steps_container">
          <div class="info_step" *ngFor="let stp of postalCodeInvestmentStages">
            <div class="absolute bg-gray-10 w-[3px] h-full top-[4px] left-[-23px] line"></div>
            <h3 class="font-sans text-xl text-eggplant-80" *ngIf="stp.title !== null && stp.title !== undefined && stp.title !== '' ">{{ stp.title }}</h3>
            <h3 class="font-sans text-xl text-eggplant-80" *ngIf="stp.title === null || stp.title === undefined || stp.title === '' ">{{ stp.name }}</h3>

            <p class="font-sans text-m text-eggplant-100/[0.4]" *ngIf="stp.description !== null && stp.description !== undefined && stp.description !== '' ">{{ stp.description }}</p>
          </div>
        </div>
        <p class="txt_1 font-sans text-l "> {{ 'LOCAL_INNVEST.STEP_0.PROJECT_PHASE' | translate }} {{ phaseP }}.
          <span *ngIf="canInvest">{{ 'LOCAL_INNVEST.STEP_0.CAN_INVEST' | translate }}</span>
          <span *ngIf="!canInvest && investmentUnlock !== undefined">{{ 'LOCAL_INNVEST.STEP_0.CANT_INVEST' | translate }} {{ timeRemaining }} {{ 'LOCAL_INNVEST.STEP_0.DAYS' | translate }}.</span>
          <!-- <span *ngIf="status !== 15" class="green" (click)="seeValidCode()">{{ 'LOCAL_INNVEST.STEP_0.SEE_ADDRESS' | translate }}.</span> -->
        </p>
      </section>
      <!---->
      <section *ngIf="step === 1">
        <h2 class="font-sans text-eggplant-100 text-3xl">{{ 'LOCAL_INNVEST.STEP_1.TITLE' | translate }}</h2>
        <p class="subtitle txt_1 font-sans text-l text-eggplant-100/[0.55]">{{ 'LOCAL_INNVEST.STEP_1.SUBTITLE' | translate:{'projectName':projectName} }}</p>

        <div class="form-container pt-32 pb-20" *ngIf="profile.profileType === 1">
          <fun-input *ngIf="profile.profileType === 1"
            placeholder="{{ 'LOCAL_INNVEST.STEP_3.DOC_TYPE' | translate }}"
            [parentForm]="documentForm"
            [formControlKeys]="formControlKeys"
            [errorMessages]="errorMessages"
            [isSubmit]="isSubmit"
            controlName="document"
            type="select"
            [errorLogin]="errorDocument"
            labelName="{{ 'LOCAL_INNVEST.STEP_3.DOC_TYPE' | translate }}"
            (selectChange)="changeDocument()"
            (keyup)="changeDocument()"
            (click)="changeDocument()"
            [items]="documentList"
            [selectedItem]="1"
          ></fun-input>
        </div>

        <div *ngIf="address !== undefined" class="address-confirm-container">
          <h4>{{ 'LOCAL_INNVEST.STEP_1.ADDRESS' | translate }}</h4>
          <p class="address txt_1 font-sans text-l text-eggplant-100/[0.55]" *ngIf="address !== undefined">{{ address }}</p>
          <p class="txt_1 font-sans text-l text-eggplant-100/[0.55]" *ngIf="address !== undefined && hasCity">{{ userCity }}</p>
        </div>
        <div *ngIf="hasAddress" class="check_container flex">
          <div class="checkbox_content">
            <div class="checkbox" [ngClass]="{ checked: sameAddressChecked }" (click)="checkAction('sameAddress')"></div>
          </div>
          <div class="">
            <p class="font-sans text-eggplant-70 text-l">{{ 'LOCAL_INNVEST.STEP_1.CONFIRM_ADDRESS' | translate }}</p>
          </div>
        </div>

      </section>
      <!---->
      <section *ngIf="step === 2">
        <h2 class="font-sans text-eggplant-100 text-3xl">{{ 'LOCAL_INNVEST.STEP_2.TITLE' | translate }}</h2>
        <p class="subtitle font-sans text-l text-eggplant-100/[0.55]">{{ 'LOCAL_INNVEST.STEP_2.SUBTITLE' | translate }}</p>
        <div class="form-container pt-32 pb-20">
          <div *ngIf="hasProfile && hasListOfTowns">
            <fun-register-person-address *ngIf="profile.profileType === 1"
              [data]="info"
              [profile]="profile"
              [towns]="towns"
              [isMobile]="false"
              (sendInfoEvent)="getAddressInfo($event)"
              (sendErrorEvent)="getAddressError($event)"
            ></fun-register-person-address>
            <!---->
            <fun-register-company-address
              *ngIf="profile.profileType === 2"
              [data]="profile"
              [towns]="towns"
              [isMobile]="false"
              (sendInfoEvent)="getAddressInfo($event)"
              (sendErrorEvent)="getAddressError($event)"
            ></fun-register-company-address>
            <!---->
          </div>
          <div *ngIf="!hasProfile || !hasListOfTowns">
            <fun-skeleton-list></fun-skeleton-list>
          </div>
        </div>
      </section>
      <!---->
      <section *ngIf="step === 3">
        <h2 class="font-sans text-eggplant-100 text-3xl">{{ 'LOCAL_INNVEST.STEP_3.TITLE' | translate }}</h2>
        <p class="subtitle font-sans text-l text-eggplant-100/[0.55]" *ngIf="profile.profileType === 2 || (fileName === 'identityDocumentFront' && !hasDniFile) || (hasDniFile && fileName !== 'identityDocumentFront')">
          {{ 'LOCAL_INNVEST.STEP_3.SUBTITLE' | translate }}
          <span *ngIf="profile.profileType === 1 && fileName === 'identityDocumentFront'">{{ 'LOCAL_INNVEST.STEP_3.PF_DOCUMENT_1' | translate }}</span>
          <span *ngIf="profile.profileType === 1 && fileName === 'census'">{{ 'LOCAL_INNVEST.STEP_3.PF_DOCUMENT_2' | translate }}</span>
          <span *ngIf="profile.profileType === 2">{{ 'LOCAL_INNVEST.STEP_3.PJ_DOCUMENT' | translate }}</span>
        </p>
        <p class="subtitle font-sans text-l text-eggplant-100/[0.55]" *ngIf="profile.profileType === 1 && fileName === 'identityDocumentFront' && hasDniFile">{{ 'LOCAL_INNVEST.STEP_3.SUBTITLE_2' | translate }}</p>
        <div class="form-container pt-32 pb-20" *ngIf="profile.profileType === 2 || (fileName === 'identityDocumentFront' && !hasDniFile) || (hasDniFile && fileName !== 'identityDocumentFront')">
          <fun-file-card
            #fileCard
            (getFile)="getFile1($event)"
            (errorEvent)="errorFile1($event)"
            [fileType]="fileName"
            [username]="profile.username"
          ></fun-file-card>
          <fun-file-card
          *ngIf="valueF === 1 && fileMain !== undefined && profile.profileType === 1"
            #dniBackCard
            (getFile)="getDniBack($event)"
            (errorEvent)="errorDniBack($event)"
            [fileType]="'identityDocumentBack'"
            [username]="profile.username"
          ></fun-file-card>
        </div>
        <div class="check_container flex" [ngClass]="{ spaceTop: fileName === 'identityDocumentFront' && hasDniFile }">
          <div class="checkbox_content flex">
            <div class="checkbox" [ngClass]="{ checked: termsChecked }" (click)="checkAction('terms')"></div>
          </div>
          <div class="">
            <p class="font-sans text-eggplant-70 text-m">{{ 'LOCAL_INNVEST.STEP_4.CHECK' | translate }}</p>
          </div>
        </div>
        <!-- Check de caso especial como Porfolio Delta de Electra Caldense -->
        <div class="flex pt-12" *ngIf="currentProjectHasEmployeeAndClientInvestmentPhase">
            <div class="">
                <ion-toggle [checked]="currentProjectHasEmployeeAndClientInvestmentPhaseChecked" (ionChange)="checkCurrentProjectHasEmployeeAndClientInvestmentPhaseChecked()"></ion-toggle>
            </div>
            <p class="text-m text-eggplant-100/[0.55] relative pl-12">{{ getCurrentProjectHasEmployeeAndClientInvestmentPhaseText() }}</p>
        </div>
      </section>
      <!---->
      <fun-overal-message *ngIf="step === 4" [text]="text" [image]="14" [btnList]="btnList" (btnEvent)="finish()"></fun-overal-message>
      <!---->
    </div>
  </div>
</div>
<div class="footer flex flex-col-reverse py-48 md:pt-24 md:pb-0 md:px-40 md:flex-row justify-between md:border-t md:border-eggplant-10 gap-8" *ngIf="step < 4 && !loading">
  <div class="md:flex justify-center items-center">
    <fun-new-button size="xl" (eventClick)="prev()" icon="arrow-left" [iconPosition]="'left'" [classExtra]="' !w-full '" [buttonType]="'ghost'" title="{{ 'AUTOINVEST.FOOTER.PREV' | translate }}" [responsive]="false"></fun-new-button>
  </div>
  <!-- <p class="footer-info" (click)="finish()">{{ 'LOCAL_INNVEST.DYNAMIC.OTHER_MOMENT' | translate }}</p> -->
  <div class="w-full md:w-fit md:flex justify-center content-center">
    <fun-new-button size="xl" (eventClick)="next()" [classExtra]="' !w-full '" [buttonType]="btnType" title="{{ 'AUTOINVEST.FOOTER.NEXT' | translate }}" icon="arrow-right" [iconPosition]="'right'" [responsive]="false"></fun-new-button>
  </div>
</div>